import React from 'react'

import Highlight from '../../Highlight'
import type { ActivityTypeComponentProps } from '../Activity'
import ActivityFooter from '../ActivityFooter'
import ActivityTitle from '../ActivityTitle'
import QuoteActivitySubtitle from '../QuoteActivitySubtitle'

import capitalize from 'lodash/capitalize'
import ActivityOwner from '../ActivityOwner'
import QuoteLabel from '../QuoteLabel'
import ActivityDot from '../ActivityDot'
import ActivityContact from '../ActivityContact'

/**
 * For simple activities that only require a "Quote was X" title
 */
export default function BasicQuoteActivity(props: ActivityTypeComponentProps) {
  const { activity, showDocTypeDetails } = props
  const activityType = activity.details.activityType

  return (
    <>
      <ActivityTitle>
        {!['archived', 'unarchived', 'downloaded'].includes(activityType) && <ActivityDot activity={activity} />}

        {showDocTypeDetails ? (
          <>
            <QuoteLabel activity={activity} /> was <Highlight>{activityType}</Highlight>
          </>
        ) : (
          <>
            <Highlight>{capitalize(activityType)}</Highlight>
          </>
        )}
        {showDocTypeDetails && (
          <>
            {activityType === 'downloaded' ? (
              <ActivityContact activity={activity} />
            ) : (
              <ActivityOwner activity={activity} />
            )}
          </>
        )}
      </ActivityTitle>
      <QuoteActivitySubtitle activity={activity} showDocTypeDetails={showDocTypeDetails} />
      <ActivityFooter timestamp={activity.details.timestamp} />
    </>
  )
}
